/**
 * The Carbon header (DESIGN.md "Navigation"): 48px on the shell color with a
 * shell-border bottom line, pinned Gray 100 in both themes (`data-shell`).
 * Left to right: the phone menu button (below 1056px), the iuvo wordmark and
 * "Guardian" at 600, a fill, the meta group (hidden below 1056px), then the
 * caller's 48px header buttons (the bell, the theme toggle).
 *
 * In normal flow, never fixed: <main> below it stays the only scroller. The
 * row clips (overflow hidden) instead of pushing buttons off-screen, and the
 * wordmark truncates first, so the bell keeps its 48px target at 390px. The
 * breadcrumb is never in the header; it opens the content in <main>.
 *
 * z-40 puts the header above the side nav (z-30) and its scrim (z-25), so a
 * header panel (the notifications dropdown, fixed under the header) stays on
 * top of the open phone drawer instead of under it.
 */
import { Link } from 'react-router-dom'
import { PhoneMenu } from './PhoneMenu'
import type { AppHeaderProps } from './types'

export function AppHeader({ onMenu, menuOpen, meta, children, homeTo = '/dashboard', navId }: AppHeaderProps) {
  return (
    <header
      data-shell=""
      aria-label="iuvo Guardian"
      className="relative z-40 flex h-12 flex-none items-stretch overflow-hidden border-b border-[color:var(--shell-border)] bg-[color:var(--shell)] text-text-primary"
    >
      <PhoneMenu open={menuOpen} onToggle={onMenu} controls={navId} />
      <Link
        to={homeTo}
        className="flex min-w-0 items-center gap-2 whitespace-nowrap pr-2 text-body font-semibold tracking-[0.1px] c-lg:pl-4 c-lg:pr-8"
      >
        <img src="/iuvo-logo-on-dark.png" alt="iuvo" width={56} height={16} className="block h-4 w-auto flex-none" />
        <span className="min-w-0 truncate">Guardian</span>
      </Link>
      <span className="min-w-0 flex-1" />
      {meta ? (
        <div className="hidden items-center gap-4 whitespace-nowrap px-4 text-helper text-text-helper c-lg:flex">{meta}</div>
      ) : null}
      {children}
    </header>
  )
}

export default AppHeader
